'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var languageMaps = [['fr', 'fr-CA'], ['es', 'es-US']];
var defaultLang = 'en';

exports.default = function (nextState, replace) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = languageMaps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var lang = _step.value;

      if (nextState.params.language.toLowerCase() === lang[0] || nextState.params.language.toLowerCase() === lang[1].toLowerCase()) {
        nextState.params.language = lang[1];
        return;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  nextState.params.language = defaultLang;
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/common/Path.js
// module id = 1771
// module chunks = 0